export const api = '0avHIUOCDyO6rN1DkHeZyEFkaO2LSLwPMewn3Bbb'
export const defaultKey = `?api_key=${api}&date=2020-07-12`